export default /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;
